export const displayLocalNameIfExists = (firstName?: string, lastName?: string) => {
    const name = `${firstName ?? ''} ${lastName ?? ''}`.trim();
    return name ? ` (${name})` : null;
};

export { ENTITY_LINK_CLASS } from 'pages/matters/util';
